import {
  CircularProgress,
  CircularProgressProps,
  Grid,
  styled,
  useTheme
} from "@mui/material";
import React from "react";

// Separar los tipos en un archivo aparte o al inicio
type LoadingType = "normal" | "full screen";
type LoadingVariant = "normal" | "gradient";

interface MxLoadingProps extends Omit<CircularProgressProps, "variant"> {
  variant?: LoadingVariant;
  size?: number;
  type?: LoadingType;
}

// Memoizar el GradientCircularProgress ya que es un componente estático
const GradientCircularProgress = React.memo((props: CircularProgressProps) => {
  const theme = useTheme();

  // Mover el SVG fuera del render para evitar recreaciones
  const gradientDef = (
    <defs>
      <linearGradient id="loading_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor={theme.palette.error.main} />
        <stop offset="100%" stopColor={theme.palette.primary.main} />
      </linearGradient>
    </defs>
  );

  return (
    <>
      <svg width={0} height={0}>
        {gradientDef}
      </svg>
      <StyledCircularProgress {...props} />
    </>
  );
});

GradientCircularProgress.displayName = "GradientCircularProgress";

// Optimizar el componente principal
const MxLoading = React.memo((props: MxLoadingProps) => {
  const { variant = "normal", type = "normal", ...rest } = props;

  const progressComponent =
    variant === "normal" ? (
      <CircularProgress {...rest} />
    ) : (
      <GradientCircularProgress {...rest} />
    );

  return (
    <ContentLoading type={type} className="testclass">
      {progressComponent}
    </ContentLoading>
  );
});

MxLoading.displayName = "MxLoading";

// Optimizar los styled components
const StyledCircularProgress = styled(CircularProgress)({
  "svg circle": { stroke: "url(#loading_gradient)" }
});

const ContentLoading = styled(Grid)<{ type: LoadingType }>(({ theme, type }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: type === "full screen" ? "calc(100vh - 64px)" : "auto"
}));

export default MxLoading;
